import { Dictionary } from "lodash";
import { TMenuOption } from "../ButtonMenu";
import { TRenderGroup } from "../ButtonMenu.types";
import { TRenderOptionProps } from "./Option";
import OptionGroup from "./OptionGroup";

type TOptionGroupsProps = {
  groups: Dictionary<TMenuOption[]>;
  renderGroup?: TRenderGroup;
} & Omit<TRenderOptionProps, "options" | "option" | "shouldBeSeparated">;

const OptionGroups = ({
  groups,
  renderGroup,
  ...props
}: TOptionGroupsProps) => (
  <>
    {Object.entries(groups).map(
      ([groupName, group]) =>
        renderGroup?.(groupName, {
          options: group,
          renderGroup: renderGroup,
          ...props,
        }) ?? (
          <OptionGroup
            key={groupName}
            groupName={groupName}
            options={group}
            renderGroup={renderGroup}
            {...props}
          />
        ),
    )}
  </>
);

export default OptionGroups;
